/** @format */

import React from "react";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { AllParams } from "../ResourcesFilter";
import { ReactComponent as Square } from "bootstrap-icons/icons/square.svg";
import { ReactComponent as CheckSquare } from "bootstrap-icons/icons/check-square-fill.svg";
import { useTranslation } from "react-i18next";
import { filterResources } from "../utils";
import { ResourceReference } from "../../../../types";

type Props = {
  isLoading?: boolean;
  query: QueryProps;
  allParams: AllParams;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  resources: ResourceReference[] | undefined;
};

const TypesFilter: React.FC<Props> = ({
  isLoading,
  query,
  allParams,
  handleQueryItemClick,
  resources,
}) => {
  const { t: _ } = useTranslation();
  let allTypes = resources
    ? [...allParams.types].map((t) => {
        const count = filterResources([...resources], "types", query).filter(
          (r) => r.Type === t.title,
        ).length;
        if (count !== t.count) {
          return { ...t, count: count };
        }
        return t;
      })
    : [...allParams.types];

  return (
    <>
      {(!!allTypes?.length || isLoading) && (
        <div className="card shadow mb-3">
          <div className="card-body" key="type-filter">
            <h5>{_("Resource Type")}</h5>
            {isLoading &&
              [1, 2, 3, 4].map((i) => (
                <button
                  key={`type${i}`}
                  className={`w-100 btn btn-light text-start py-0 mb-2`}
                >
                  <Square />
                  &emsp;<span className="placeholder col-5"></span>{" "}
                  <span className="float-end placeholder col-1"></span>
                </button>
              ))}

            {allTypes
              ?.sort((a, b) => (a.title < b.title ? -1 : 1))
              .map((_type) => (
                <button
                  key={_type.title}
                  onClick={() => handleQueryItemClick(_type.title, "types")}
                  className={`w-100 btn btn-light text-start py-0 mb-2`}
                >
                  {query.types?.includes(_type.title) ? (
                    <CheckSquare />
                  ) : (
                    <Square />
                  )}
                  &emsp;
                  {_(_type.title)}
                  <span className="text-muted float-end">{_type.count}</span>
                </button>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TypesFilter;
